import Icon from "@ant-design/icons";
import {Image} from "antd";
import {
    CPSIconImg
} from "../../../../assets";


export const MyIcon = (props) => <Image src={CPSIconImg} preview={false}/>
